angular.module('zc.projects')

.directive 'zcCampaignIncentiveTable', ->
  restrict: 'E'
  scope:
    campaign: '='
    showsAction: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_incentive_table.html'
  link: (scope, element, attrs) ->
    scope.remove = (incentive) ->
      scope.campaign.incentives = _.reject scope.campaign.incentives, incentive, 'id'
      scope.campaign.incentive_ids = _.map scope.campaign.incentives, 'id'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_incentive_table.directive.coffee